import * as React from "react";

import { SLOT_ELEMENT_TYPE_SYMBOL } from "@fluentui/react-utilities";

// eslint-disable-next-line no-restricted-imports
import type {
  AppFlyoutAnchorProps,
  AppFlyoutAnchorState,
} from "@1js/acui-button/lib/Next";
// eslint-disable-next-line no-restricted-imports
import { useAppFlyoutAnchor } from "@1js/acui-button/lib/Next";
import { MeasuredContext } from "@1js/acui-resize-group";
import { shouldShadowRender } from "@1js/acui-shadow-rendering";

import { RibbonMenuButton } from "./RibbonMenuButton";
import type { RibbonFlyoutAnchorProps } from "./RibbonFlyoutAnchor.types";

export const useRibbonFlyoutAnchor = (
  props: RibbonFlyoutAnchorProps,
  ref: React.Ref<HTMLButtonElement>
): AppFlyoutAnchorState => {
  const { dataAutomationType, shadowRenderMenu } = props;

  // Getting context and app settings to enable/disable shadow rendering
  const measuredContext = React.useContext(MeasuredContext);

  const state = useAppFlyoutAnchor(
    {
      ...props,
      dataAutomationType: dataAutomationType ?? "RibbonFlyoutAnchor",
      persistMenu: true,
      preventCalloutDismissOnScroll: true,
      shadowRenderMenu: shouldShadowRender(
        shadowRenderMenu,
        measuredContext.isMeasured
      ),
    } as AppFlyoutAnchorProps,
    ref
  );

  // We want to render a RibbonMenuButton instead of an AppMenuButton
  if (state.components) {
    state.components.menuButton = RibbonMenuButton;
    (state.menuButton as any)[SLOT_ELEMENT_TYPE_SYMBOL] = RibbonMenuButton;
  }

  return state;
};
